import { lazy } from 'react';
import { appMenu, dashboardPagesMenu, demoPagesMenu, hiddenMenu, pageLayoutTypesPagesMenu } from '../menu';
import AnsweredSurveyDetailPage from '../pages/presentation/answered-survey/AnsweredSurveyDetailPage';
import AnsweredSurveyPage from '../pages/presentation/answered-survey/AnsweredSurveyPage';
import { FirstAccessPage } from '../pages/presentation/auth/FirstAccessPage';
import Login from '../pages/presentation/auth/Login';
import { TokenPage } from '../pages/presentation/auth/TokenPage';
import CompanyPage from '../pages/presentation/company/CompanyPage';
import CostCenterPage from '../pages/presentation/cost-center/CostCenterPage';
import CustomerPage from '../pages/presentation/customer/CustomerPage';
import EmployeePage from '../pages/presentation/employee/EmployeePage';
import JobTitlePage from '../pages/presentation/job-title/JobTitlePage';
import PermissionPage from '../pages/presentation/permission/PermissionPage';
import ServicePage from '../pages/presentation/service/ServicePage';
import SurveyDetailsPage from '../pages/presentation/survey-settings/SurveySettingsPage';
import SurveyPage from '../pages/presentation/survey/SurveyPage';
import TrainingEmployeePage from '../pages/presentation/training-employee/TrainingEmployeePage';
import TrainingPage from '../pages/presentation/training/TrainingPage';
import WorkOrderDetailPage from '../pages/presentation/work-order/WorkOrderDetailPage';
import WorkOrderPage from '../pages/presentation/work-order/WorkOrderPage';
import WorkOrderViewPage from '../pages/presentation/work-order/WorkOrderViewPage';
import WorkResourceEmployeePage from '../pages/presentation/work-resource-employee/WorkResourceEmployeePage';
import ExpiringWorkResourcePage from '../pages/presentation/work-resource/ExpiringWorkResourcesPage';
import WorkResourcePage from '../pages/presentation/work-resource/WorkResourcePage';

const LANDING = {
    DASHBOARD: lazy(() => import('../pages/presentation/dashboard/DashboardPage')),
};
const AUTH = {
    PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};
const PAGE_LAYOUTS = {
    HEADER_SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/HeaderAndSubheader')),
    HEADER: lazy(() => import('../pages/presentation/page-layouts/OnlyHeader')),
    SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/OnlySubheader')),
    CONTENT: lazy(() => import('../pages/presentation/page-layouts/OnlyContent')),
    BLANK: lazy(() => import('../pages/presentation/page-layouts/Blank')),
    ASIDE: lazy(() => import('../pages/presentation/aside-types/DefaultAsidePage')),
    MINIMIZE_ASIDE: lazy(() => import('../pages/presentation/aside-types/MinimizeAsidePage')),
};

const presentation = [
    /**
     * Landing
     */
    {
        path: dashboardPagesMenu.dashboard.path,
        element: <LANDING.DASHBOARD />,
    },
    {
        path: demoPagesMenu.page404.path,
        element: <AUTH.PAGE_404 />,
    },
    {
        path: demoPagesMenu.login.path,
        element: <Login />,
    },
    {
        path: demoPagesMenu.signUp.path,
        element: <Login isSignUp />,
    },
    {
        path: demoPagesMenu.firstAccess.path,
        element: <FirstAccessPage />,
    },
    {
        path: demoPagesMenu.token.path,
        element: <TokenPage />,
    },

    /** ************************************************** */

    /**
     * Page Layout Types
     */
    {
        path: pageLayoutTypesPagesMenu.blank.path,
        element: <PAGE_LAYOUTS.BLANK />,
    },
    {
        path: pageLayoutTypesPagesMenu.pageLayout.subMenu.headerAndSubheader.path,
        element: <PAGE_LAYOUTS.HEADER_SUBHEADER />,
    },
    {
        path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyHeader.path,
        element: <PAGE_LAYOUTS.HEADER />,
    },
    {
        path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path,
        element: <PAGE_LAYOUTS.SUBHEADER />,
    },
    {
        path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path,
        element: <PAGE_LAYOUTS.CONTENT />,
    },
    {
        path: pageLayoutTypesPagesMenu.asideTypes.subMenu.defaultAside.path,
        element: <PAGE_LAYOUTS.ASIDE />,
    },
    {
        path: pageLayoutTypesPagesMenu.asideTypes.subMenu.minimizeAside.path,
        element: <PAGE_LAYOUTS.MINIMIZE_ASIDE />,
    },

    /**
     * App Menu
     */
    {
        path: appMenu.registers.subMenu.companies.path,
        element: <CompanyPage />,
    },
    {
        path: appMenu.registers.subMenu.costCenters.path,
        element: <CostCenterPage />,
    },
    {
        path: appMenu.registers.subMenu.jobTitles.path,
        element: <JobTitlePage />,
    },
    {
        path: appMenu.registers.subMenu.workResources.path,
        element: <WorkResourcePage />,
    },
    {
        path: appMenu.registers.subMenu.employees.path,
        element: <EmployeePage />,
    },
    {
        path: appMenu.registers.subMenu.permissions.path,
        element: <PermissionPage />,
    },
    {
        path: appMenu.registers.subMenu.trainings.path,
        element: <TrainingPage />,
    },
    {
        path: appMenu.registers.subMenu.surveys.path,
        element: <SurveyPage />,
    },
    {
        path: appMenu.operations.subMenu.surveys.path,
        element: <AnsweredSurveyPage />,
    },
    {
        path: appMenu.operations.subMenu.expiringWorkResources.path,
        element: <ExpiringWorkResourcePage />,
    },
        {
        path: appMenu.operations.subMenu.workOrders.path,
        element: <WorkOrderPage />,
    },

    {
        path: hiddenMenu.workResourceEmployees.path,
        element: <WorkResourceEmployeePage />,
    },
    {
        path: hiddenMenu.trainingEmployees.path,
        element: <TrainingEmployeePage />,
    },
    {
        path: hiddenMenu.surveySettings.path,
        element: <SurveyDetailsPage />,
    },
    {
        path: hiddenMenu.answeredSurveyDetail.path,
        element: <AnsweredSurveyDetailPage />,
    },
    {
        path: appMenu.registers.subMenu.customers.path,
        element: <CustomerPage />,
    },
        {
        path: appMenu.registers.subMenu.services.path,
        element: <ServicePage />,
    },
    {
        path: hiddenMenu.workOrderDetail.path,
        element: <WorkOrderDetailPage />,
    },
        {
        path: hiddenMenu.workOrderView.path,
        element: <WorkOrderViewPage />,
    },
];
const contents = [...presentation];

export default contents;
